import moment from 'moment';
import _ from 'lodash';

function displayClock(val) {
  let hrs = 0;
  let mins = 0;
  if (!val) val = 0;
  if (val < 60) { hrs = 0; mins = 0; } else {
    hrs = parseInt((val / 3600), 10);
    mins = parseInt(((val % 3600) / 60), 10);
  }
  return { hrs, mins };
}
function addLeadingZero(val) {
  if (val < 10) return `0${val}`;
  return val;
}

export default {
  fullDateTime: (val) => (val ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : ''),
  headerTitle: (title) => {
    const htmlStart = title.indexOf(' <i');
    const headerName = htmlStart === -1 ? title : title.substring(0, htmlStart);
    const html = htmlStart === -1 ? '' : title.substring(htmlStart, title.length - 1);
    if (headerName.toUpperCase().includes('SKU')) return headerName + html;
    if (['ID', 'QA'].includes(headerName.toUpperCase())) return headerName.toUpperCase() + html;
    if (['BOMS', 'LEAD TIME (DAYS)'].includes(headerName.toUpperCase())) return headerName + html;
    if (headerName.indexOf('-') >= 0) return headerName;
    return _.startCase(_.toLower(headerName)).replace('Id', 'ID') + html;
  },
  clockDisplayInSecs: (val) => {
    const { hrs, mins } = displayClock(val);
    const secs = parseInt((val % 60), 10);
    return `${addLeadingZero(hrs)}:${addLeadingZero(mins)}:${addLeadingZero(secs)}`;
  },
  clockDisplay: (val) => {
    const { hrs, mins } = displayClock(val);
    return `${addLeadingZero(hrs)}:${addLeadingZero(mins)}`;
  },
  usaDate: (val) => (val ? moment(val).format('MM/DD/YYYY') : ''),
};
